&nbsp;
<div class="loader" [ngClass]="{ white }"></div>
